import React, { Fragment, useEffect, useState } from "react";
import { set_vendor_store } from "../../redux/actions/StoreAction";
import { set_orders } from "../../redux/actions/OrdersAction";
import { set_user } from "../../redux/actions/AuthAction";
import { set_logout } from "../../redux/actions/LogoutAction";
import { connect } from "react-redux";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { FaSignOutAlt } from "react-icons/fa";
import { set_page_state } from "../../redux/actions/PageStateAction";
import $ from "jquery";
import { Redirect } from "react-router";
import "./header.scss";
import { ReactComponent as UAE } from "../../assets/icons/uae.svg";
import { ReactComponent as KSA } from "../../assets/icons/ksa.svg";
import { ReactComponent as EGYPT } from "../../assets/icons/egypt.svg";
import { authUrl2 } from "../../api/Constants";
import "react-toastify/dist/ReactToastify.css";

const Header = (props) => {
  const [signingOut, setSigningOut] = useState(false);

  const [redirectToLogin, setRedirectToLogin] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  $.auth.configure({
    apiUrl: authUrl2,
  });
  useEffect(() => {
    apiJson.vendorProfile.getVendorProfile().then((response) => {
      if (response.success) {
        props.set_vendor_store({ vendorStore: response.data });
      }
      //  else if (!response.status) {
      //   // eslint-disable-next-line
      //   message = response.message
      //     ? response.message !== ""
      //       ? response.message
      //       : "something went wrong"
      //     : "something went wrong";
      //   showError();
      // } else {
      //   if (response.status >= 400 && response.status < 500) {
      //     message = response.message
      //       ? response.message
      //       : response.errors
      //       ? response.errors
      //       : "something went wrong";
      //     showError();
      //   } else {
      //     message = response.message
      //       ? response.message !== ""
      //         ? response.message
      //         : "something went wrong"
      //       : "something went wrong";
      //     showError();
      //   }
      // }
    });
  }, []);

  const signOut = () => {
    setSigningOut(true);
    apiJson.auth.signout().then((response) => {
      if (response.success) {
        document.cookie =
          "authHeaders=undefined; expires= Thu, 21 Aug 2014 20:00:00 UTC";
        props.set_user({ isSignedIn: false, user: {} });
        props.set_vendor_store({ vendorStore: {} });
        props.set_page_state({ pageState: { id: 1 } });
        localStorage.clear();
        setRedirectToLogin(true);
        props.set_logout({});
      } else {
        setSigningOut(false);
        if (
          parseInt(response.error?.response?.status) === 404 ||
          parseInt(response.error?.response?.status) === 401
        ) {
          document.cookie =
            "authHeaders=undefined; expires= Thu, 21 Aug 2014 20:00:00 UTC";
          props.set_user({ isSignedIn: false, user: {} });
          props.set_vendor_store({ vendorStore: {} });
          props.set_page_state({ pageState: { id: 1 } });
          localStorage.clear();
          setRedirectToLogin(true);
          props.set_logout({});
        } else {
          message =
            props.language === "ar" ? "هناك خطأ ما" : "something went wrong";
          showError();
        }
      }
    });
  };

  const flags = [<UAE />, <KSA />, <EGYPT />];
  return (
    <Fragment>
      <div className=" vendor-header-desktop row g-0">
        <div className="main col">
          <span className="sp-country">
            {flags[props.vendorStore.country_id - 1]}
          </span>
          <div className="sp-address">
            <span className="sub-add">
              Hi,
              <span className="vendor-name">
                {props.user?.first_name_en
                  ? props.user?.first_name_en
                  : props.user?.last_name_en}
              </span>
            </span>
            <span className="sp-loc">{props.user?.email}</span>
          </div>
          <span
            className={`signout`}
            onClick={!signingOut ? signOut : undefined}
          >
            {signingOut ? (
              <ClipLoader color="#000" size="19px" />
            ) : (
              <FaSignOutAlt />
            )}
          </span>
        </div>
      </div>

      {redirectToLogin && <Redirect push to="/" />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return { vendorStore: state.vendorStore.vendorStore, user: state.auth.user };
};

const mapDispatchTopProps = {
  set_vendor_store,
  set_user,
  set_orders,
  set_logout,
  set_page_state,
};

export default connect(mapStateToProps, mapDispatchTopProps)(Header);
